<template>
    <div>
        <input
            class="form-control"
            type="file"
            name="file"
            ref="file"
            @change="handleFileUpload()"
        />
        <button
            class="btn btn-primary"
            @click.prevent="submitFile"
        >Submit
        </button>
    </div>
</template>

<script>
    import {API_IMPORT} from "../../constants";

    export default {
        data(){
            return {
                file: '',
                apiImport: API_IMPORT
            }
        },
        methods: {
            submitFile(){
                const config = { 'content-type': 'multipart/form-data' }
                const formData = new FormData();
                formData.append('file', this.file);

                api.call("post", this.apiImport, formData, config)
                    .then(({data}) => {
                        console.log('success')
                    })
            },
            handleFileUpload(){
                this.file = this.$refs.file.files[0];
            }
        }
    }


</script>

